<template>
  <v-container fluid class="pa-4 pt-0 mt-0">
    <!-- Header -->
    <v-row align="center" justify="center">
      <v-col cols="12" md="auto" class="my-0 py-0">
        <div class="d-flex align-center justify-center">
          <v-avatar color="primary" size="44" class="mr-3 elevation-2">
            <v-icon color="white">mdi-clipboard-list-outline</v-icon>
          </v-avatar>
          <div>
            <div class="text-h5 font-weight-bold grey--text text--darken-2">Órdenes del Kiosco</div>
            <div class="text-caption grey--text">Gestión de órdenes de venta del kiosco</div>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Filtros -->
    <v-row justify="center">
      <v-col cols="12">
        <search-header-po @dataFilters="changeBusiness($event)" :selected_week="1" :show_refresh="false" />
      </v-col>
    </v-row>

    <!-- Tarjetas de estadísticas o foto del empleado -->
    <v-card class="rounded-lg elevation-1 mt-3">
      <v-card-text>
        <v-row no-gutters align="center">
          <!-- Mostrar foto del empleado cuando hay búsqueda por código -->
          <v-col cols="12" md="9" v-if="isEmployeeCodeSearch">
            <div class="d-flex align-center justify-center pa-4">
              <v-card class="pa-4 text-center" outlined>
                <v-avatar size="120" class="mb-3">
                  <v-img :src="`http://128.1.0.233:3001/api/recruitment/persons/file/${employeeCodeSearch}`"
                    :alt="`Empleado ${employeeCodeSearch}`" @error="onImageError">
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>
                <div class="text-h5 font-weight-bold">
                  Empleado: {{ employeeCodeSearch }}
                </div>
                <div class="text-subtitle-1 grey--text">
                  {{ filteredOrders.length }} orden(es) encontrada(s)
                </div>
              </v-card>
            </div>
          </v-col>

          <!-- Tarjetas de estadísticas (cuando no hay búsqueda por empleado) -->
          <v-col cols="12" md="6" v-else>
            <v-row>
              <v-col v-for="status in statuses" :key="status.id" cols="12" sm="4" class="pa-2">
                <v-card :color="status.color" dark class="rounded-lg elevation-4 status-card"
                  :class="`bg-gradient-${status.color}`" @click="toggleStatusFilter(status.id)">
                  <v-card-text class="text-center pa-4">
                    <div class="d-flex justify-space-between align-center mb-2">
                      <span class="text-h6">{{ status.label }}</span>
                      <v-icon>{{ status.active ? "mdi-eye" : "mdi-eye-off" }}</v-icon>
                    </div>
                    <div class="text-h3 font-weight-bold">
                      {{ getOrderCountByStatus(status.id) }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>

          <!-- Panel de filtros -->
          <v-col cols="12" md="6">
            <v-card outlined class="rounded-lg pa-3 ml-4">
              <!-- <v-card-title class="text-h6 pb-2">
                <v-icon left>mdi-filter-variant</v-icon>
                Filtros
              <</v-card-title> -->
              <v-row>
                <v-col cols="8">
                  <v-row>
                    <v-switch v-for="status in statuses" :key="'switch-' + status.id" v-model="status.active"
                      :color="status.color" :label="status.label" class="my-1 mx-4" hide-details inset dense></v-switch>
                  </v-row>
                </v-col>

                <v-col cols="4">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" outlined block v-bind="attrs" v-on="on" class="mr-16">
                        <v-icon left>mdi-cog</v-icon>
                        Configuraciones
                        <v-icon right>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item v-if="hasFeature('ING-032')" @click="openLocationsConfigDialog">
                        <v-list-item-icon>
                          <v-icon color="purple">mdi-map-marker-multiple</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Configurar Ubicaciones</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item v-if="hasFeature('ING-032')" @click="openKioscoMenuDialog">
                        <v-list-item-icon>
                          <v-icon color="teal">mdi-storefront</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Menú Kiosco</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>

                <!-- Dropdown de configuraciones -->
              </v-row>

              <v-divider class="my-3"></v-divider>

              <!-- <v-select
                v-model="selectedLocation"
                :items="packingLocations"
                item-text="location_name"
                item-value="id"
                label="Ubicación"
                outlined
                dense
                clearable
                prepend-inner-icon="mdi-map-marker"
                :disabled="isEmployeeCodeSearch"
                class="mb-3"
              ></v-select> -->

              <!-- Botón para búsqueda por código de empleado -->
              <v-btn color="orange" outlined block @click="openEmployeeSearchDialog" class="mb-2">
                <v-icon left>mdi-account-search</v-icon>
                Buscar por Código
              </v-btn>

              <!-- 
              <v-divider class="my-3"></v-divider> -->

              <!-- Búsqueda por código de empleado -->
              <v-text-field v-show="false" v-model="employeeCodeSearch" label="Buscar por Código de Empleado" outlined
                dense clearable prepend-inner-icon="mdi-account-search" @input="searchByEmployeeCode"
                @click:clear="clearEmployeeCodeSearch" hint="Busca todas las órdenes del empleado en el rango de fechas"
                persistent-hint></v-text-field>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Tabla principal -->
    <v-card class="rounded-lg elevation-3 mt-3">
      <v-card-title class="headline font-weight-bold">
        <v-icon left color="primary" size="28">mdi-clipboard-list-outline</v-icon>
        Órdenes del Kiosco
        <v-chip class="ml-2" color="primary" small>
          {{ filteredOrders.length }}
        </v-chip>
        <v-chip v-if="isEmployeeCodeSearch" class="ml-2" color="orange" small close @click:close="clearEmployeeSearch">
          Código: {{ employeeCodeSearch }}
        </v-chip>
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on: onMute, attrs: attrsMute }">
            <v-btn icon @click="audioMuted = !audioMuted" class="mr-1" v-bind="attrsMute" v-on="onMute">
              <v-icon :color="audioMuted ? 'grey' : 'primary'">
                {{ audioMuted ? 'mdi-volume-off' : 'mdi-volume-high' }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ audioMuted ? 'Alertas silenciadas' : 'Alertas activas' }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="refreshData" :loading="loading" class="mr-2" v-bind="attrs" v-on="on">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Actualizar ahora (refresco automático en {{ refreshTimeLeft }}s)</span>
        </v-tooltip>
        <v-chip x-small color="grey lighten-2" class="mr-2 font-weight-medium">
          <v-icon x-small left>mdi-clock-outline</v-icon>
          {{ refreshTimeLeft }}s
        </v-chip>

        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar factura, cliente..." single-line
          hide-details outlined dense style="max-width: 300px" clearable></v-text-field>
      </v-card-title>

      <v-progress-linear :value="(20 - refreshTimeLeft) * 5" color="primary" height="2"></v-progress-linear>

      <v-data-table :headers="headers" :items="filteredOrders" :search="search" :items-per-page="15" :page.sync="page"
        @page-count="pageCount = $event" :loading="loading" class="elevation-0" :item-class="rowClass" :footer-props="{
          'items-per-page-options': [15, 30, 50],
          'items-per-page-text': 'Filas por página:',
        }">
        <!-- Número de factura -->
        <template v-slot:[`item.invoice_number`]="{ item }">
          <div>
            <span @click="showInvoice(item.invoice_id, true)" class="font-weight-medium cursor-pointer primary--text">
              {{ item.invoice_number }}
            </span>
            <div class="text-caption grey--text">ID: {{ item.invoice_id }}</div>
          </div>
        </template>

        <!-- Total -->
        <template v-slot:[`item.total_amount`]="{ item }">
          <div class="text-right">
            <span class="font-weight-medium">
              {{ currencyFormat(item.total_amount) }} {{ item.currency_code }}
            </span>
          </div>
        </template>

        <!-- Cliente -->
        <template v-slot:[`item.entity_name`]="{ item }">
          <div>
            <span class="font-weight-medium">{{ item.entity_name }}</span>
            <div v-if="item.responsable_entity_name" class="text-caption grey--text">
              {{ item.responsable_entity_name }}
            </div>
          </div>
        </template>

        <!-- Fecha -->
        <template v-slot:[`item.created_date`]="{ item }">
          <div class="text-center">
            <div class="font-weight-medium">{{ formatDate(item.created_date) }}</div>
            <div class="text-caption grey--text">{{ formatTime(item.created_date) }}</div>
          </div>
        </template>

        <!-- Tiempo transcurrido -->
        <template v-slot:[`item.elapsed`]="{ item }">
          <div class="text-center">
            <v-chip x-small :color="getElapsedColor(item.created_date, item.status_order_id)"
              :dark="isElapsedUrgent(item.created_date, item.status_order_id)" class="font-weight-medium">
              <v-icon x-small left>mdi-timer-outline</v-icon>
              {{ getElapsedLabel(item.created_date) }}
            </v-chip>
          </div>
        </template>

        <!-- Estado -->
        <template v-slot:[`item.status_order_id`]="{ item }">
          <v-chip small :color="getStatusColor(item.status_order_id)" :outlined="item.status_order_id === 1"
            :dark="item.status_order_id !== 1">
            <v-icon left small>{{ getStatusIcon(item.status_order_id) }}</v-icon>
            {{ getStatusLabel(item.status_order_id) }}
          </v-chip>
        </template>

        <!-- Ubicación -->
        <template v-slot:[`item.location_info`]="{ item }">
          <div>
            <div v-if="item.pack_location" class="text-caption">
              <v-icon small color="blue">mdi-package-variant</v-icon>
              {{ item.pack_location }}
            </div>
            <div v-if="item.dispatch_location" class="text-caption mt-1">
              <v-icon small color="green">mdi-truck-delivery</v-icon>
              {{ item.dispatch_location }}
            </div>
            <span v-if="!item.pack_location && !item.dispatch_location" class="text-caption grey--text">-</span>
          </div>
        </template>

        <!-- Tracking -->
        <template v-slot:[`item.tracking_info`]="{ item }">
          <div>
            <v-chip v-if="item.tracking_number" x-small color="info" outlined>
              {{ item.tracking_number }}
            </v-chip>
            <v-chip v-else-if="item.tracking_code" x-small color="blue" outlined>
              {{ item.tracking_code }}
            </v-chip>
            <span v-else class="text-caption grey--text">-</span>
          </div>
        </template>

        <!-- Acciones -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex">
            <!-- Empacar -->
            <v-tooltip top v-if="item.status_order_id === 1 && hasFeature('ING-032')">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="blue" v-bind="attrs" v-on="on" @click="openPackDialog(item)" class="mr-1">
                  <v-icon>mdi-package-variant</v-icon>
                </v-btn>
              </template>
              <span>Empacar</span>
            </v-tooltip>

            <!-- Despachar -->
            <v-tooltip top v-if="item.status_order_id === 2 && hasFeature('ING-032')">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="green" v-bind="attrs" v-on="on" @click="openDispatchDialog(item)" class="mr-1">
                  <v-icon>mdi-truck-delivery</v-icon>
                </v-btn>
              </template>
              <span>Despachar</span>
            </v-tooltip>

            <!-- Detalles -->
            <v-tooltip top v-if="item.status_order_id === 3">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="orange" v-bind="attrs" v-on="on" @click="showOrderDetails(item)" class="mr-1">
                  <v-icon>mdi-information</v-icon>
                </v-btn>
              </template>
              <span>Ver Detalles</span>
            </v-tooltip>

            <!-- Imprimir -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="primary" v-bind="attrs" v-on="on" @click="printTicket(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
              </template>
              <span>Imprimir</span>
            </v-tooltip>
          </div>
        </template>

        <!-- Sin datos -->
        <template v-slot:no-data>
          <div class="text-center pa-10">
            <div class="mb-4 d-inline-block">
              <v-icon size="80" color="blue lighten-4">mdi-package-variant-closed</v-icon>
            </div>
            <div class="text-h5 font-weight-bold grey--text text--darken-2 mb-2">Pantalla Limpia</div>
            <div class="text-body-1 grey--text text--darken-1 mb-6">
              {{ isEmployeeCodeSearch
                ? 'No se encontraron órdenes para este código de empleado en el rango de fechas seleccionado.'
                : 'No hay órdenes pendientes en este momento. ¡Buen trabajo!' }}
            </div>
            <v-btn color="primary" class="px-8 rounded-lg pulse-animation" @click="refreshData" large depressed>
              <v-icon left>mdi-refresh</v-icon>
              Verificar ahora
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialog empacar -->
    <v-dialog v-model="packDialog" max-width="700px" persistent>
      <v-card>
        <v-card-title class="headline blue white--text">
          <v-icon left color="white">mdi-package-variant</v-icon>
          Empacar Orden {{ selectedOrder?.invoice_number }}
        </v-card-title>

        <v-card-text class="pt-4">
          <v-container>
            <v-row>
              <v-alert icon="mdi-information" text color="blue" class="mb-3 rounded-lg border-left-alert"
                colored-border>
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <div class="text-h6 blue--text text--darken-2 font-weight-bold">
                      {{ selectedOrder?.entity_name }}
                    </div>
                    <div class="text-caption grey--text text--darken-1">
                      Cod. Empleado: <strong>{{ selectedOrder?.employee_code || 'N/A' }}</strong> |
                      Unidad: <strong>{{ selectedOrder?.business_unit_description }}</strong>
                    </div>
                    <div class="text-caption grey--text text--darken-1">
                      Responsable: <strong>{{ selectedOrder?.responsable_entity_name || 'N/A' }}</strong>
                    </div>
                  </div>
                  <div class="text-right">
                    <div class="text-subtitle-1 font-weight-bold">
                      {{ currencyFormat(selectedOrder?.total_amount) }}
                    </div>
                    <div class="text-caption grey--text">{{ selectedOrder?.currency_code }}</div>
                  </div>
                </div>
              </v-alert>

              <!-- Lista de ítems de la orden -->
              <v-col cols="12" v-if="selectedOrderItems.length > 0">
                <div class="text-subtitle-2 mb-2 d-flex align-center">
                  <v-icon small left color="blue">mdi-layers-triple</v-icon>
                  <span class="font-weight-bold">Artículos a Empacar</span>
                  <v-spacer></v-spacer>
                  <v-chip x-small color="blue lighten-4" class="blue--text font-weight-bold">
                    {{ selectedOrderItems.length }} ítems
                  </v-chip>
                </div>

                <v-card outlined class="rounded-lg overflow-hidden">
                  <v-list dense class="pa-0 scrollbar-custom" style="max-height: 220px; overflow-y: auto">
                    <template v-for="(itm, idx) in selectedOrderItems">
                      <v-list-item :key="'item-' + idx" class="px-3 border-bottom-light">
                        <v-list-item-avatar size="32" color="blue lighten-5" rounded>
                          <v-img v-if="itm.image_json && itm.image_json.documents"
                            :src="`https://api_sipe.comandpos.com/api/files/${itm.image_json.collectionId}/${itm.image_json.id}/${itm.image_json.documents}`"></v-img>
                          <v-icon v-else color="blue" small>mdi-package-variant-closed</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title class="text-body-2 font-weight-medium">
                            {{ itm.item_name || itm.item_description }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="text-caption grey--text d-flex align-center">
                            <span class="mr-2">{{ itm.unit_name }}</span>
                            <v-icon x-small color="grey lighten-1">mdi-circle-small</v-icon>
                            <span class="ml-2">{{ currencyFormat(itm.price) }} / ud</span>
                          </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action class="my-auto align-end">
                          <div class="text-h6 font-weight-bold primary--text">
                            × {{ itm.quantity }}
                          </div>
                          <div class="text-caption grey--text">
                            {{ currencyFormat(itm.total_amount) }}
                          </div>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider v-if="idx < selectedOrderItems.length - 1" :key="'div-' + idx"></v-divider>
                    </template>
                  </v-list>
                </v-card>
              </v-col>
              <v-col cols="12" v-else-if="packItemsLoading">
                <v-progress-linear indeterminate color="blue" class="mb-3"></v-progress-linear>
              </v-col>

              <v-col cols="12">
                <v-select v-model="packForm.packing_location_id" :items="packingLocations" item-text="location_name"
                  item-value="id" label="Ubicación de Empaque *" outlined required></v-select>
              </v-col>

              <!-- <v-col cols="12">
                <v-select
                  v-model="packForm.priority_level"
                  :items="priorityLevels"
                  item-text="text"
                  item-value="value"
                  label="Prioridad"
                  outlined
                ></v-select>
              </v-col> -->

              <v-col cols="12">
                <v-textarea v-model="packForm.notes" label="Notas" outlined rows="2"></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closePackDialog"> Cancelar </v-btn>
          <v-btn color="blue" dark :loading="packLoading" @click="packOrder">
            <v-icon left>mdi-package-variant</v-icon>
            Empacar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog despachar -->
    <v-dialog v-model="dispatchDialog" max-width="700px" persistent>
      <v-card>
        <v-card-title class="headline green white--text">
          <v-icon left color="white">mdi-truck-delivery</v-icon>
          Despachar Orden {{ selectedOrder?.invoice_number }}
        </v-card-title>

        <v-card-text class="pt-4">
          <v-container>
            <v-row>
              <v-alert icon="mdi-truck-delivery" text color="green" class="mb-3 rounded-lg border-left-alert-green"
                colored-border>
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <div class="text-h6 green--text text--darken-2 font-weight-bold">
                      {{ selectedOrder?.entity_name }}
                    </div>
                    <div class="text-caption grey--text text--darken-1">
                      Cod. Empleado: <strong>{{ selectedOrder?.employee_code || 'N/A' }}</strong> |
                      Unidad: <strong>{{ selectedOrder?.business_unit_description }}</strong>
                    </div>
                    <div class="text-caption grey--text text--darken-1">
                      Responsable: <strong>{{ selectedOrder?.responsable_entity_name || 'N/A' }}</strong>

                    </div>
                    <div class="text-caption green--text font-weight-bold mt-1">
                      <v-icon x-small color="green">mdi-package-variant</v-icon>
                      Empacada en: {{ selectedOrder?.pack_location }}
                    </div>
                  </div>
                  <div class="text-right">
                    <div class="text-subtitle-1 font-weight-bold">
                      {{ currencyFormat(selectedOrder?.total_amount) }}
                    </div>
                    <div class="text-caption grey--text">{{ selectedOrder?.currency_code }}</div>
                  </div>
                </div>
              </v-alert>

              <!-- Lista de ítems de la orden -->
              <v-col cols="12" v-if="selectedOrderItems.length > 0">
                <div class="text-subtitle-2 mb-2 d-flex align-center">
                  <v-icon small left color="green">mdi-layers-triple</v-icon>
                  <span class="font-weight-bold">Artículos a Despachar</span>
                  <v-spacer></v-spacer>
                  <v-chip x-small color="green lighten-4" class="green--text font-weight-bold">
                    {{ selectedOrderItems.length }} ítems
                  </v-chip>
                </div>

                <v-card outlined class="rounded-lg overflow-hidden">
                  <v-list dense class="pa-0 scrollbar-custom" style="max-height: 200px; overflow-y: auto">
                    <template v-for="(itm, idx) in selectedOrderItems">
                      <v-list-item :key="'dispatch-item-' + idx" class="px-3 border-bottom-light">
                        <v-list-item-avatar size="32" color="green lighten-5" rounded>
                          <v-img v-if="itm.image_json && itm.image_json.documents"
                            :src="`https://api_sipe.comandpos.com/api/files/${itm.image_json.collectionId}/${itm.id}/${itm.image_json.documents}`"></v-img>
                          <v-icon v-else color="green" small>mdi-package-variant-closed</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title class="text-body-2 font-weight-medium">
                            {{ itm.item_name || itm.item_description }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="text-caption grey--text">
                            {{ itm.unit_name }} | {{ currencyFormat(itm.price) }} / ud
                          </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action class="my-auto align-end">
                          <div class="text-h6 font-weight-bold green--text">
                            × {{ itm.quantity }}
                          </div>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider v-if="idx < selectedOrderItems.length - 1" :key="'dispatch-div-' + idx"></v-divider>
                    </template>
                  </v-list>
                </v-card>
              </v-col>
              <v-col cols="12" v-else-if="packItemsLoading">
                <v-progress-linear indeterminate color="green" class="mb-3"></v-progress-linear>
              </v-col>

              <v-col cols="12">
                <v-select v-model="dispatchForm.dispatch_method" :items="dispatchMethods" item-text="text"
                  item-value="value" label="Método de Despacho *" outlined required></v-select>
              </v-col>

              <v-col cols="12" v-if="
                dispatchForm.dispatch_method === 'DELIVERY' ||
                dispatchForm.dispatch_method === 'COURIER'
              ">
                <v-textarea v-model="dispatchForm.delivery_address" label="Dirección de Entrega *" outlined required
                  rows="3"></v-textarea>
              </v-col>

              <v-col cols="12" v-if="dispatchForm.dispatch_method === 'COURIER'">
                <v-text-field v-model="dispatchForm.courier_name" label="Nombre del Courier" outlined></v-text-field>
              </v-col>

              <v-col cols="6" v-if="dispatchForm.dispatch_method === 'COURIER'">
                <v-text-field v-model="dispatchForm.courier_phone" label="Teléfono" outlined></v-text-field>
              </v-col>

              <v-col cols="6" v-if="dispatchForm.dispatch_method === 'COURIER'">
                <v-text-field v-model="dispatchForm.vehicle_plate" label="Placa" outlined></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-textarea v-model="dispatchForm.dispatch_notes" label="Notas de Despacho" outlined
                  rows="3"></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeDispatchDialog"> Cancelar </v-btn>
          <v-btn color="green" :loading="dispatchLoading" @click="dispatchOrder">
            <v-icon left>mdi-truck-delivery</v-icon>
            Despachar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog detalles -->
    <v-dialog v-model="detailsDialog" max-width="800px">
      <v-card>
        <v-card-title class="headline orange white--text">
          <v-icon left color="white">mdi-information</v-icon>
          Detalles de Orden {{ orderDetails?.invoice_number }}
        </v-card-title>

        <v-card-text class="pt-4" v-if="orderDetails">
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field :value="orderDetails.current_status_name" label="Estado Actual" outlined
                  readonly></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field :value="orderDetails.tracking_number || 'N/A'" label="Tracking" outlined
                  readonly></v-text-field>
              </v-col>

              <v-col cols="6" v-if="orderDetails.pack_location">
                <v-text-field :value="orderDetails.pack_location" label="Ubicación Empaque" outlined
                  readonly></v-text-field>
              </v-col>

              <v-col cols="6" v-if="orderDetails.packed_at">
                <v-text-field :value="formatDateTime(orderDetails.packed_at)" label="Fecha Empaque" outlined
                  readonly></v-text-field>
              </v-col>

              <v-col cols="6" v-if="orderDetails.dispatch_method">
                <v-text-field :value="orderDetails.dispatch_method" label="Método Despacho" outlined
                  readonly></v-text-field>
              </v-col>

              <v-col cols="6" v-if="orderDetails.dispatched_at">
                <v-text-field :value="formatDateTime(orderDetails.dispatched_at)" label="Fecha Despacho" outlined
                  readonly></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="detailsDialog = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog búsqueda por código de empleado -->
    <v-dialog v-model="employeeSearchDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline orange white--text">
          <v-icon left color="white">mdi-account-search</v-icon>
          Buscar por Código de Empleado
        </v-card-title>

        <v-card-text class="pt-4">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-alert type="info" outlined class="mb-4">
                  Busca todas las órdenes del empleado en el rango de fechas seleccionado
                </v-alert>
              </v-col>

              <v-col cols="12">
                <v-text-field v-model="employeeCodeInput" label="Código de Empleado *" outlined required
                  prepend-inner-icon="mdi-account" @keyup.enter="executeEmployeeSearch" autofocus></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeEmployeeSearchDialog"> Cancelar </v-btn>
          <v-btn color="orange" :loading="loading" @click="executeEmployeeSearch"
            :disabled="!employeeCodeInput || !employeeCodeInput.trim()">
            <v-icon left>mdi-magnify</v-icon>
            Buscar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog configuración de ubicaciones -->
    <v-dialog v-model="locationsConfigDialog" max-width="1200px" persistent>
      <v-card>
        <v-card-title class="headline purple white--text">
          <v-icon left color="white">mdi-cog</v-icon>
          Configuración de Ubicaciones de Empaque
          <v-spacer></v-spacer>
          <v-btn color="white" outlined @click="openLocationFormDialog" class="mr-2">
            <v-icon left>mdi-plus</v-icon>
            Nueva Ubicación
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-container>
            <!-- Tabla de ubicaciones -->
            <v-data-table :headers="locationHeaders" :items="allPackingLocations" :loading="locationsLoading"
              class="elevation-1" :items-per-page="10" :footer-props="{
                'items-per-page-options': [10, 25, 50],
                'items-per-page-text': 'Filas por página:',
              }">
              <!-- Código -->
              <template v-slot:[`item.location_code`]="{ item }">
                <v-chip small :color="item.is_active ? 'primary' : 'grey'" outlined>
                  {{ item.location_code }}
                </v-chip>
              </template>

              <!-- Tipo de área -->
              <!-- <template v-slot:[`item.area_type`]="{ item }">
                <v-chip small :color="getAreaTypeColor(item.area_type)" dark>
                  {{ getAreaTypeLabel(item.area_type) }}
                </v-chip>
              </template> -->

              <!-- Estado -->
              <template v-slot:[`item.is_active`]="{ item }">
                <v-chip small :color="item.is_active ? 'success' : 'error'" dark>
                  {{ item.is_active ? "Activa" : "Inactiva" }}
                </v-chip>
              </template>

              <!-- Fechas -->
              <template v-slot:[`item.created_at`]="{ item }">
                <div class="text-caption">
                  {{ formatDateTime(item.created_at) }}
                  <br />
                  <span class="grey--text">{{ item.created_by_name }}</span>
                </div>
              </template>

              <!-- Acciones -->
              <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small color="primary" v-bind="attrs" v-on="on" @click="editLocation(item)"
                        class="mr-1">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>

                  <v-tooltip top v-if="item.is_active">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small color="error" v-bind="attrs" v-on="on" @click="deactivateLocation(item)"
                        class="mr-1">
                        <v-icon>mdi-eye-off</v-icon>
                      </v-btn>
                    </template>
                    <span>Desactivar</span>
                  </v-tooltip>

                  <v-tooltip top v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small color="success" v-bind="attrs" v-on="on" @click="activateLocation(item)">
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>Activar</span>
                  </v-tooltip>
                </div>
              </template>

              <!-- Sin datos -->
              <template v-slot:no-data>
                <div class="text-center pa-8">
                  <v-icon size="64" color="grey lighten-1" class="mb-4">
                    mdi-map-marker-off
                  </v-icon>
                  <div class="text-h6 mb-2">No hay ubicaciones configuradas</div>
                  <div class="text-body-2 grey--text">
                    Crea la primera ubicación de empaque
                  </div>
                </div>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeLocationsConfigDialog"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog formulario de ubicación -->
    <v-dialog v-model="locationFormDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline" :class="isEditingLocation ? 'orange white--text' : 'green white--text'">
          <v-icon left color="white">
            {{ isEditingLocation ? "mdi-pencil" : "mdi-plus" }}
          </v-icon>
          {{ isEditingLocation ? "Editar Ubicación" : "Nueva Ubicación" }}
        </v-card-title>

        <v-card-text class="pt-4">
          <v-container>
            <v-form ref="locationForm" v-model="locationFormValid">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="locationForm.location_code" label="Código de Ubicación *" outlined required
                    :rules="[rules.required, rules.locationCode]" hint="Código único para identificar la ubicación"
                    persistent-hint :disabled="isEditingLocation"></v-text-field>
                </v-col>

                <!-- <v-col cols="12" md="6">
                  <v-select
                    v-model="locationForm.area_type"
                    :items="areaTypes"
                    item-text="text"
                    item-value="value"
                    label="Tipo de Área *"
                    outlined
                    required
                    :rules="[rules.required]"
                  ></v-select>
                </v-col> -->

                <v-col cols="12">
                  <v-text-field v-model="locationForm.location_name" label="Nombre de Ubicación *" outlined required
                    :rules="[rules.required, rules.locationName]" hint="Nombre descriptivo de la ubicación"
                    persistent-hint></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-textarea v-model="locationForm.location_description" label="Descripción" outlined rows="3"
                    hint="Descripción opcional de la ubicación" persistent-hint></v-textarea>
                </v-col>

                <v-col cols="12" v-if="isEditingLocation">
                  <v-switch v-model="locationForm.is_active" label="Ubicación Activa" color="success" inset></v-switch>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeLocationFormDialog"> Cancelar </v-btn>
          <v-btn :color="isEditingLocation ? 'orange' : 'green'" :loading="locationFormLoading" @click="saveLocation"
            :disabled="!locationFormValid">
            <v-icon left>
              {{ isEditingLocation ? "mdi-content-save" : "mdi-plus" }}
            </v-icon>
            {{ isEditingLocation ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog menú kiosco -->
    <v-dialog v-model="kioscoMenuDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="teal">
          <v-btn icon dark @click="closeKioscoMenuDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <v-icon left>mdi-storefront</v-icon>
            Menú Kiosco - Gestión de Artículos Express
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="white" outlined @click="openAddToMenuDialog" class="mr-2">
            <v-icon left>mdi-plus</v-icon>
            Agregar al Menú
          </v-btn>
          <v-btn color="white" outlined @click="refreshKioscoItems" class="mr-2">
            <v-icon left>mdi-refresh</v-icon>
            Actualizar
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-4">
          <v-container>
            <!-- Tabla de artículos del kiosco -->
            <v-data-table :headers="kioscoHeaders" :items="kioscoItems" :loading="kioscoLoading" class="elevation-1"
              :items-per-page="15" :footer-props="{
                'items-per-page-options': [15, 25, 50],
                'items-per-page-text': 'Filas por página:',
              }" :search="kioscoSearch">
              <!-- Barra de búsqueda -->
              <template v-slot:top>
                <v-toolbar flat>
                  <v-text-field v-model="kioscoSearch" append-icon="mdi-magnify" label="Buscar artículos..." single-line
                    hide-details outlined dense class="mr-4"></v-text-field>
                </v-toolbar>
              </template>

              <!-- Imagen del artículo -->
              <template v-slot:[`item.item_image_url`]="{ item }">
                <v-avatar size="40" class="ma-1">
                  <v-img v-if="item.item_image_url" :src="item.item_image_url" :alt="item.item_name"></v-img>
                  <v-icon v-else color="grey">mdi-package-variant</v-icon>
                </v-avatar>
              </template>

              <!-- Código del artículo -->
              <template v-slot:[`item.code`]="{ item }">
                <v-chip small color="primary" outlined>
                  {{ item.code }}
                </v-chip>
              </template>

              <!-- Nombre del artículo -->
              <template v-slot:[`item.item_name`]="{ item }">
                <div>
                  <div class="font-weight-medium">{{ item.item_name }}</div>
                  <div class="text-caption grey--text" v-if="item.item_note">
                    {{ item.item_note }}
                  </div>
                </div>
              </template>

              <!-- Categoría -->
              <template v-slot:[`item.catalogue_category_name`]="{ item }">
                <v-chip small color="blue" outlined>
                  {{ item.catalogue_category_name }}
                </v-chip>
              </template>

              <!-- Acciones -->
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn color="red" small @click="removeItemFromKioscoMenu(item)" :loading="item.removing"
                  :disabled="item.removing">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>

              <!-- Sin datos -->
              <template v-slot:no-data>
                <div class="text-center pa-8">
                  <v-icon size="64" color="grey lighten-1" class="mb-4">
                    mdi-storefront-outline
                  </v-icon>
                  <div class="text-h6 mb-2">No hay artículos disponibles</div>
                  <div class="text-body-2 grey--text">
                    No se encontraron artículos en el catálogo
                  </div>
                </div>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog agregar artículos al menú -->
    <v-dialog v-model="addToMenuDialog" max-width="1200px" persistent>
      <v-card>
        <v-card-title class="headline blue white--text">
          <v-icon left color="white">mdi-plus-circle</v-icon>
          Agregar Artículos al Menú Kiosco
          <v-spacer></v-spacer>
          <v-btn color="white" outlined @click="refreshAvailableItems" class="mr-2">
            <v-icon left>mdi-refresh</v-icon>
            Actualizar
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-container fluid>
            <v-data-table :headers="availableItemsHeaders" :items="availableItems" :search="availableItemsSearch"
              :loading="loadingAvailableItems" item-key="item_id" class="elevation-1" :items-per-page="10"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Artículos por página:',
                'page-text': '{0}-{1} de {2}',
              }">
              <template v-slot:top>
                <v-toolbar flat>
                  <v-text-field v-model="availableItemsSearch" append-icon="mdi-magnify"
                    label="Buscar artículos disponibles..." single-line hide-details outlined dense
                    class="mr-4"></v-text-field>
                </v-toolbar>
              </template>

              <!-- Imagen del artículo -->
              <template v-slot:[`item.item_image_url`]="{ item }">
                <v-avatar size="40" class="ma-1">
                  <v-img v-if="item.item_image_url" :src="item.item_image_url" :alt="item.item_name"></v-img>
                  <v-icon v-else color="grey">mdi-package-variant</v-icon>
                </v-avatar>
              </template>

              <!-- Código del artículo -->
              <template v-slot:[`item.code`]="{ item }">
                <v-chip small color="primary" outlined>
                  {{ item.code }}
                </v-chip>
              </template>

              <!-- Nombre del artículo -->
              <template v-slot:[`item.item_name`]="{ item }">
                <div>
                  <div class="font-weight-medium">{{ item.item_name }}</div>
                  <div class="text-caption grey--text" v-if="item.item_note">
                    {{ item.item_note }}
                  </div>
                </div>
              </template>

              <!-- Categoría -->
              <template v-slot:[`item.catalogue_category_name`]="{ item }">
                <v-chip small color="blue" outlined>
                  {{ item.catalogue_category_name }}
                </v-chip>
              </template>

              <!-- Acción agregar -->
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn color="teal" small @click="addItemToKioscoMenu(item)" :loading="item.adding"
                  :disabled="item.adding">
                  <v-icon left small>mdi-plus</v-icon>
                  Agregar
                </v-btn>
              </template>

              <!-- Sin datos -->
              <template v-slot:no-data>
                <div class="text-center pa-8">
                  <v-icon size="64" color="grey lighten-1" class="mb-4">
                    mdi-package-variant-closed
                  </v-icon>
                  <div class="text-h6 mb-2">No hay artículos disponibles</div>
                  <div class="text-body-2 grey--text">
                    Todos los artículos ya están en el menú kiosco
                  </div>
                </div>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeAddToMenuDialog"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import "moment-timezone";

export default {
  name: "KioskOrderManagement",

  data() {
    return {
      statuses: [
        { id: 1, label: "NUEVAS", color: "red", active: true },
        { id: 2, label: "EMPACADAS", color: "blue", active: true },
        { id: 3, label: "DESPACHADAS", color: "green", active: true },
      ],

      page: 1,
      pageCount: 0,
      search: "",
      loading: false,
      packLoading: false,
      dispatchLoading: false,
      selectedLocation: null,

      // Employee code search
      employeeCodeSearch: "",
      isEmployeeCodeSearch: false,
      employeeSearchDialog: false,
      packDialog: false,
      dispatchDialog: false,
      detailsDialog: false,

      selectedOrder: null,
      orderDetails: null,

      packForm: {
        packing_location_id: null,
        notes: "",
        estimated_items: null,
        actual_items: null,
        priority_level: 1,
      },

      dispatchForm: {
        dispatch_method: "PICKUP",
        delivery_address: "",
        courier_name: "",
        courier_phone: "",
        vehicle_plate: "",
        dispatch_notes: "",
      },

      invoices: [],
      packingLocations: [],

      priorityLevels: [
        { text: "Normal", value: 1 },
        { text: "Alta", value: 2 },
        { text: "Urgente", value: 3 },
      ],

      dispatchMethods: [
        { text: "Recoger en Tienda", value: "PICKUP" },
        // { text: "Entrega a Domicilio", value: "DELIVERY" },
        // { text: "Servicio de Courier", value: "COURIER" },
      ],

      headers: [
        { text: "Factura", value: "invoice_number", width: "13%" },
        { text: "Fecha", value: "created_date", width: "10%" },
        { text: "Espera", value: "elapsed", sortable: false, width: "9%" },
        { text: "Cliente", value: "entity_name", width: "18%" },
        { text: "Total", value: "total_amount", align: "end", width: "10%" },
        { text: "Estado", value: "status_order_id", width: "10%" },
        { text: "Ubicación", value: "location_info", width: "13%" },
        { text: "Tracking", value: "tracking_info", width: "9%" },
        { text: "Acciones", value: "actions", sortable: false, width: "10%" },
      ],

      lastFilters: {},
      timerId: null,
      refreshTimeLeft: 20,
      employeeCodeInput: "",
      audioMuted: false,
      selectedOrderItems: [],
      packItemsLoading: false,

      // Configuración de ubicaciones
      locationsConfigDialog: false,
      locationFormDialog: false,
      locationFormValid: false,
      locationFormLoading: false,
      locationsLoading: false,
      isEditingLocation: false,
      allPackingLocations: [],

      locationForm: {
        id: null,
        location_code: "",
        location_name: "",
        location_description: "",
        area_type: "PACKING",
        is_active: true,
      },

      locationHeaders: [
        { text: "Código", value: "location_code", width: "15%" },
        { text: "Nombre", value: "location_name", width: "25%" },
        { text: "Descripción", value: "location_description", width: "25%" },
        { text: "Tipo", value: "area_type", width: "12%" },
        { text: "Estado", value: "is_active", width: "10%" },
        { text: "Creado", value: "created_at", width: "15%" },
        { text: "Acciones", value: "actions", sortable: false, width: "13%" },
      ],

      areaTypes: [
        { text: "Empaque", value: "PACKING" },
        { text: "Despacho", value: "DISPATCH" },
        { text: "Almacén", value: "STORAGE" },
      ],

      // Menú Kiosco
      kioscoMenuDialog: false,
      kioscoLoading: false,
      kioscoItems: [],
      kioscoSearch: "",

      kioscoHeaders: [
        { text: "Imagen", value: "item_image_url", sortable: false, width: "8%" },
        { text: "Código", value: "code", width: "12%" },
        { text: "Artículo", value: "item_name", width: "30%" },
        { text: "Categoría", value: "catalogue_category_name", width: "18%" },
        { text: "Tipo", value: "item_type_name", width: "15%" },
        //  { text: "Creado por", value: "created_by_name", width: "17%" },
        { text: "Acciones", value: "actions", sortable: false, width: "10%" },
      ],

      // Agregar artículos al menú
      addToMenuDialog: false,
      loadingAvailableItems: false,
      availableItems: [],
      availableItemsSearch: "",

      availableItemsHeaders: [
        { text: "Imagen", value: "item_image_url", sortable: false, width: "10%" },
        { text: "Código", value: "code", width: "15%" },
        { text: "Artículo", value: "item_name", width: "30%" },
        { text: "Categoría", value: "catalogue_category_name", width: "20%" },
        { text: "Tipo", value: "item_type_name", width: "15%" },
        { text: "Acciones", value: "actions", sortable: false, width: "10%" },
      ],

      rules: {
        required: (value) => !!value || "Este campo es requerido",
        locationCode: (value) => {
          if (!value) return "El código es requerido";
          if (value.length < 2) return "El código debe tener al menos 2 caracteres";
          if (value.length > 10) return "El código no puede tener más de 10 caracteres";
          if (!/^[A-Z0-9_-]+$/.test(value))
            return "Solo se permiten letras mayúsculas, números, guiones y guiones bajos";
          return true;
        },
        locationName: (value) => {
          if (!value) return "El nombre es requerido";
          if (value.trim().length < 3)
            return "El nombre debe tener al menos 3 caracteres";
          if (value.length > 100) return "El nombre no puede tener más de 100 caracteres";
          return true;
        },
      },
    };
  },

  computed: {
    filteredOrders() {
      return this.invoices.filter((invoice) => {
        const statusActive = this.statuses.find((s) => s.id === invoice.status_order_id)?.active;
        const locationMatch =
          !this.selectedLocation || invoice.pack_location_id === this.selectedLocation;
        // When isEmployeeCodeSearch mode, still apply status and location filters but ignore nothing
        return statusActive && locationMatch;
      });
    },
  },

  created() {
    this.init();

    // Timer interval checking every second
    this.timerId = setInterval(() => {
      if (this.refreshTimeLeft > 0) {
        this.refreshTimeLeft--;
      } else {
        this.refreshTimeLeft = 20; // reset
        if (this.lastFilters && Object.keys(this.lastFilters).length > 0) {
          if (this.isEmployeeCodeSearch) {
            this.getDataByEmployeeCode();
          } else {
            this.getData(this.lastFilters);
          }
        }
      }
    }, 1000);
  },

  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.timerId) {
      clearInterval(this.timerId);
    }
    document.title = 'Kiosco — Órdenes';
  },

  watch: {
    invoices() {
      this.updateTabTitle();
    },
  },

  methods: {
    rowClass(item) {
      if (item.status_order_id === 1) {
        return 'new-order-row';
      }
      return '';
    },
    playDing() {
      if (this.audioMuted) return;
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return;
        const ctx = new AudioContext();
        const osc = ctx.createOscillator();
        const gainNode = ctx.createGain();
        osc.type = "sine";
        osc.connect(gainNode);
        gainNode.connect(ctx.destination);
        osc.frequency.setValueAtTime(880, ctx.currentTime);
        gainNode.gain.setValueAtTime(0, ctx.currentTime);
        gainNode.gain.linearRampToValueAtTime(1, ctx.currentTime + 0.01);
        gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 1);
        osc.start(ctx.currentTime);
        osc.stop(ctx.currentTime + 1);
      } catch (e) {
        console.error("Audio play error", e);
      }
    },

    getElapsedMinutes(date) {
      return Math.floor((Date.now() - new Date(date).getTime()) / 60000);
    },

    getElapsedLabel(date) {
      const mins = this.getElapsedMinutes(date);
      if (mins < 1) return '< 1 min';
      if (mins < 60) return `${mins} min`;
      const hrs = Math.floor(mins / 60);
      const rem = mins % 60;
      return rem > 0 ? `${hrs}h ${rem}m` : `${hrs}h`;
    },

    getElapsedColor(date, statusId) {
      if (statusId !== 1) return 'grey lighten-1';
      const mins = this.getElapsedMinutes(date);
      if (mins >= 30) return 'red';
      if (mins >= 15) return 'orange';
      return 'green';
    },

    isElapsedUrgent(date, statusId) {
      if (statusId !== 1) return false;
      return this.getElapsedMinutes(date) >= 15;
    },

    updateTabTitle() {
      const pending = this.invoices.filter(i => i.status_order_id === 1).length;
      if (pending > 0) {
        document.title = `(${pending}) Kiosco — Órdenes Pendientes`;
      } else {
        document.title = 'Kiosco — Órdenes';
      }
    },
    async init() {
      await this.loadPackingLocations();
    },

    async loadPackingLocations() {
      try {
        const response = await this.api_Get("income/packing_locations");
        if (response.ok) {
          this.packingLocations = await response.json();
        }
      } catch (error) {
        this.$toast.error("Error cargando ubicaciones");
      }
    },

    async getData(data) {
      this.lastFilters = data;
      this.loading = true;

      try {
        let filters = "";
        filters +=
          "AND INVOICES.invoice_type_id in(5) and invoices.status_order_id in(1,2,3) ";
        filters +=
          data.business == null
            ? " "
            : " AND BUSINESS_UNITS.ID in (" + data.business + ") ";
        filters +=
          data.location == null || data.location == 0
            ? ""
            : " AND LOCATION_ID IN (" + data.location + ")";
        filters +=
          " AND EMISSION_DATE::DATE BETWEEN '" +
          this.lastFilters.dateStart +
          "' and '" +
          this.lastFilters.dateEnd +
          "' ";

        const response = await this.api_Post("income/invoice_order_sales_list_enhanced", {
          filters: filters,
        });

        if (response.ok) {
          const newInvoices = await response.json();
          // Detect if there are NEW orders (status_order_id === 1) that were not in this.invoices
          if (this.invoices.length > 0) {
            const oldNewOrdersIds = this.invoices.filter(i => i.status_order_id === 1).map(i => i.invoice_id);
            const hasNew = newInvoices.some(i => i.status_order_id === 1 && !oldNewOrdersIds.includes(i.invoice_id));
            if (hasNew) {
              this.playDing();
            }
          }
          this.invoices = newInvoices;
          this.refreshTimeLeft = 20; // reset on load
        }
      } catch (error) {
        this.$toast.error("Error cargando órdenes del kiosco");
      } finally {
        this.loading = false;
      }
    },

    openEmployeeSearchDialog() {
      this.employeeCodeInput = "";
      this.employeeSearchDialog = true;
    },

    closeEmployeeSearchDialog() {
      this.employeeSearchDialog = false;
      this.employeeCodeInput = "";
    },

    executeEmployeeSearch() {
      if (!this.employeeCodeInput || !this.employeeCodeInput.trim()) {
        this.$toast.error("Ingresa un código de empleado");
        return;
      }

      this.employeeCodeSearch = this.employeeCodeInput.trim();
      this.isEmployeeCodeSearch = true;
      this.closeEmployeeSearchDialog();
      this.getDataByEmployeeCode();
    },

    clearEmployeeSearch() {
      this.employeeCodeSearch = "";
      this.isEmployeeCodeSearch = false;
      this.refreshData();
    },

    searchByEmployeeCode() {
      if (this.employeeCodeSearch && this.employeeCodeSearch.trim()) {
        this.isEmployeeCodeSearch = true;
        this.getDataByEmployeeCode();
      } else {
        this.isEmployeeCodeSearch = false;
        // Return to normal filtered data
        this.refreshData();
      }
    },

    clearEmployeeCodeSearch() {
      this.employeeCodeSearch = "";
      this.isEmployeeCodeSearch = false;
      this.refreshData();
    },

    onImageError() {
      // Handle image loading error - could show a default avatar
      console.error("Error loading employee image");
    },

    refreshData() {
      this.refreshTimeLeft = 20;
      if (this.lastFilters && Object.keys(this.lastFilters).length > 0) {
        if (this.isEmployeeCodeSearch) {
          this.getDataByEmployeeCode();
        } else {
          this.getData(this.lastFilters);
        }
      }
    },

    changeBusiness(data) {
      // Clear employee search when changing business filters

      this.lastFilters.business = data.business;
      this.employeeCodeSearch = "";
      this.isEmployeeCodeSearch = false;

      if (data.business == 0) {
        this.getData({
          business: this.$store.state.auth.user.acess_business_unit_finance,
          location: null,
          dateStart: data.dateStart,
          dateEnd: data.dateEnd,
        });
      } else {
        this.getData(data);
      }
    },

    toggleStatusFilter(statusId) {
      const status = this.statuses.find((s) => s.id === statusId);
      if (status) {
        status.active = !status.active;
      }
    },

    getOrderCountByStatus(statusId) {
      return this.invoices.filter((invoice) => invoice.status_order_id === statusId)
        .length;
    },

    async openPackDialog(order) {
      this.selectedOrder = order;
      this.selectedOrderItems = [];
      this.packForm = {
        packing_location_id: null,
        notes: "",
        estimated_items: null,
        actual_items: null,
        priority_level: 1,
      };
      this.packDialog = true;
      // Load order items
      this.packItemsLoading = true;
      try {
        const response = await this.api_Post("income/search_invoice_id", {
          number: order.invoice_id,
        });
        if (response.ok) {
          const data = await response.json();
          if (data && data[0]) {
            this.selectedOrderItems = data[0].invoice_details || data[0].details || data[0].items || [];
          }
        }
      } catch (e) {
        // silently ignore
      } finally {
        this.packItemsLoading = false;
      }
    },

    closePackDialog() {
      this.packDialog = false;
      this.selectedOrder = null;
      this.selectedOrderItems = [];
    },

    async packOrder() {
      if (!this.packForm.packing_location_id) {
        this.$toast.error("Selecciona una ubicación");
        return;
      }

      this.packLoading = true;
      try {
        const response = await this.api_Post("income/pack_order", {
          invoice_id: this.selectedOrder.invoice_id,
          packing_location_id: this.packForm.packing_location_id,
          packed_by: this.$store.state.auth.user.user.user_id,
          notes: this.packForm.notes,
          estimated_items: this.packForm.estimated_items,
          actual_items: this.packForm.actual_items,
          priority_level: this.packForm.priority_level,
        });

        if (response.ok) {
          const result = await response.json();
          if (result.success) {
            this.$toast.success("Orden empacada exitosamente");
            this.closePackDialog();
            this.refreshData();
          } else {
            this.$toast.error(result.message);
          }
        }
      } catch (error) {
        this.$toast.error("Error empacando orden");
      } finally {
        this.packLoading = false;
      }
    },

    async openDispatchDialog(order) {
      this.selectedOrder = order;
      this.selectedOrderItems = [];
      this.dispatchForm = {
        dispatch_method: "PICKUP",
        delivery_address: "",
        courier_name: "",
        courier_phone: "",
        vehicle_plate: "",
        dispatch_notes: "",
      };
      this.dispatchDialog = true;

      // Load order items
      this.packItemsLoading = true;
      try {
        const response = await this.api_Post("income/search_invoice_id", {
          number: order.invoice_id,
        });
        if (response.ok) {
          const data = await response.json();
          if (data && data[0]) {
            this.selectedOrderItems = data[0].invoice_details || data[0].details || data[0].items || [];
          }
        }
      } catch (e) {
        // silently ignore
      } finally {
        this.packItemsLoading = false;
      }
    },

    closeDispatchDialog() {
      this.dispatchDialog = false;
      this.selectedOrder = null;
      this.selectedOrderItems = [];
    },

    async dispatchOrder() {
      if (
        (this.dispatchForm.dispatch_method === "DELIVERY" ||
          this.dispatchForm.dispatch_method === "COURIER") &&
        !this.dispatchForm.delivery_address
      ) {
        this.$toast.error("La dirección es requerida");
        return;
      }

      this.dispatchLoading = true;
      try {
        const courierInfo = this.dispatchForm.courier_name
          ? {
            name: this.dispatchForm.courier_name,
            phone: this.dispatchForm.courier_phone,
            vehicle_plate: this.dispatchForm.vehicle_plate,
          }
          : null;

        const response = await this.api_Post("income/dispatch_order", {
          invoice_id: this.selectedOrder.invoice_id,
          dispatched_by: this.$store.state.auth.user.user.user_id,
          dispatch_method: this.dispatchForm.dispatch_method,
          delivery_address: this.dispatchForm.delivery_address,
          courier_info: courierInfo,
          dispatch_notes: this.dispatchForm.dispatch_notes,
        });

        if (response.ok) {
          const result = await response.json();
          if (result.success) {
            this.$toast.success(`Orden despachada. Tracking: ${result.tracking_number}`);
            this.closeDispatchDialog();
            this.refreshData();
          } else {
            this.$toast.error(result.message);
          }
        }
      } catch (error) {
        this.$toast.error("Error despachando orden");
      } finally {
        this.dispatchLoading = false;
      }
    },

    async showOrderDetails(order) {
      try {
        const response = await this.api_Post("income/order_status", {
          invoice_id: order.invoice_id,
        });

        if (response.ok) {
          this.orderDetails = await response.json();
          this.detailsDialog = true;
        }
      } catch (error) {
        this.$toast.error("Error cargando detalles");
      }
    },

    async printTicket(item) {
      try {
        const response = await this.api_Post("income/search_invoice_id", {
          number: item.invoice_id,
        });

        if (response.ok) {
          let invoice = await response.json();
          let newInvoice = invoice[0];
          newInvoice.printer_setting = {
            red: true,
            usb: false,
            name: "",
            enabled: false,
            ip_server: "128.1.0.171",
            ip_printer: "172.31.22.60",
            puerto_server: 9100,
          };
          await this.api_print_ticket(newInvoice);
          this.$toast.success("Ticket enviado a impresora");
        }
      } catch (error) {
        this.$toast.error("Error imprimiendo ticket");
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    formatTime(date) {
      return moment(date).tz("America/Santo_Domingo").format("hh:mm A");
    },

    formatDateTime(date) {
      return moment(date).tz("America/Santo_Domingo").format("DD/MM/YYYY hh:mm A");
    },

    currencyFormat(amount) {
      if (amount == null || isNaN(amount)) return "$0.00";
      return new Intl.NumberFormat("es-DO", {
        style: "currency",
        currency: "DOP",
        minimumFractionDigits: 2,
      }).format(amount);
    },
    async getDataByEmployeeCode() {
      if (!this.employeeCodeSearch || !this.lastFilters) return;

      this.loading = true;

      try {
        let filters = "";
        // Search by employee code without status restrictions
        filters += "AND INVOICES.invoice_type_id in(5) ";
        filters += "AND employee_code = '" + this.employeeCodeSearch.trim() + "' ";
        filters +=
          this.lastFilters.business == null
            ? " "
            : " AND BUSINESS_UNITS.ID in (" + this.lastFilters.business + ") ";
        filters +=
          this.lastFilters.location == null || this.lastFilters.location == 0
            ? ""
            : " AND LOCATION_ID IN (" + this.lastFilters.location + ")";
        filters +=
          " AND EMISSION_DATE::DATE BETWEEN '" +
          this.lastFilters.dateStart +
          "' and '" +
          this.lastFilters.dateEnd +
          "' ";

        const response = await this.api_Post("income/invoice_order_sales_list_enhanced", {
          filters: filters,
        });

        if (response.ok) {
          const newInvoices = await response.json();
          // Detect new orders and play ding
          if (this.invoices.length > 0) {
            const oldIds = this.invoices.filter(i => i.status_order_id === 1).map(i => i.invoice_id);
            const hasNew = newInvoices.some(i => i.status_order_id === 1 && !oldIds.includes(i.invoice_id));
            if (hasNew) this.playDing();
          }
          this.invoices = newInvoices;
          this.refreshTimeLeft = 20;
        }
      } catch (error) {
        this.$toast.error("Error buscando por código de empleado");
      } finally {
        this.loading = false;
      }
    },
    getStatusColor(statusId) {
      const status = this.statuses.find((s) => s.id === statusId);
      return status ? status.color : "grey";
    },

    getStatusIcon(statusId) {
      switch (statusId) {
        case 1:
          return "mdi-alert-circle-outline";
        case 2:
          return "mdi-package-variant-closed";
        case 3:
          return "mdi-truck-delivery-outline";
        default:
          return "mdi-help";
      }
    },

    getStatusLabel(statusId) {
      switch (statusId) {
        case 1:
          return "Pendiente";
        case 2:
          return "Empacada";
        case 3:
          return "Despachada";
        default:
          return "Desconocido";
      }
    },

    // Métodos para configuración de ubicaciones
    async openLocationsConfigDialog() {
      this.locationsConfigDialog = true;
      await this.loadAllPackingLocations();
    },

    closeLocationsConfigDialog() {
      this.locationsConfigDialog = false;
    },

    async loadAllPackingLocations() {
      this.locationsLoading = true;
      try {
        const response = await this.api_Get("income/packing_locations/all");
        if (response.ok) {
          this.allPackingLocations = await response.json();
        }
      } catch (error) {
        this.$toast.error("Error cargando ubicaciones");
      } finally {
        this.locationsLoading = false;
      }
    },

    openLocationFormDialog() {
      this.isEditingLocation = false;
      this.locationForm = {
        id: null,
        location_code: "",
        location_name: "",
        location_description: "",
        area_type: "PACKING",
        is_active: true,
      };
      this.locationFormDialog = true;
    },

    closeLocationFormDialog() {
      this.locationFormDialog = false;
      this.isEditingLocation = false;
      if (this.$refs.locationForm) {
        this.$refs.locationForm.resetValidation();
      }
    },

    editLocation(location) {
      this.isEditingLocation = true;
      this.locationForm = {
        id: location.id,
        location_code: location.location_code,
        location_name: location.location_name,
        location_description: location.location_description || "",
        area_type: location.area_type,
        is_active: location.is_active,
      };
      this.locationFormDialog = true;
    },

    async saveLocation() {
      if (!this.$refs.locationForm.validate()) {
        return;
      }

      this.locationFormLoading = true;
      try {
        let response;
        const payload = {
          ...this.locationForm,
          business_unit_id: this.lastFilters.business,
          created_by: this.$store.state.auth.user.user.user_id,
          updated_by: this.$store.state.auth.user.user.user_id,
        };

        if (this.isEditingLocation) {
          // PUT request for update
          response = await this.api_Put(
            `income/packing_locations/${this.locationForm.id}`,
            payload
          );
        } else {
          // POST request for create
          response = await this.api_Post("income/packing_locations", payload);
        }

        if (response.ok) {
          this.$toast.success(
            this.isEditingLocation
              ? "Ubicación actualizada exitosamente"
              : "Ubicación creada exitosamente"
          );
          this.closeLocationFormDialog();
          await this.loadAllPackingLocations();
          await this.loadPackingLocations(); // Refresh active locations
        } else {
          const error = await response.json();
          this.$toast.error(error.error || "Error guardando ubicación");
        }
      } catch (error) {
        this.$toast.error("Error guardando ubicación");
      } finally {
        this.locationFormLoading = false;
      }
    },

    async activateLocation(location) {
      try {
        const response = await this.api_Patch(
          `income/packing_locations/${location.id}/activate`,
          {
            updated_by: this.$store.state.auth.user.user.user_id,
          }
        );

        if (response.ok) {
          this.$toast.success("Ubicación activada");
          await this.loadAllPackingLocations();
          await this.loadPackingLocations();
        } else {
          const error = await response.json();
          this.$toast.error(error.error || "Error activando ubicación");
        }
      } catch (error) {
        this.$toast.error("Error activando ubicación");
      }
    },

    async deactivateLocation(location) {
      try {
        const response = await this.api_Delete(
          `income/packing_locations/${location.id}`,
          {
            updated_by: this.$store.state.auth.user.user.user_id,
          }
        );

        if (response.ok) {
          this.$toast.success("Ubicación desactivada");
          await this.loadAllPackingLocations();
          await this.loadPackingLocations();
        } else {
          const error = await response.json();
          this.$toast.error(error.error || "Error desactivando ubicación");
        }
      } catch (error) {
        this.$toast.error("Error desactivando ubicación");
      }
    },

    getAreaTypeColor(areaType) {
      switch (areaType) {
        case "PACKING":
          return "blue";
        case "DISPATCH":
          return "green";
        case "STORAGE":
          return "orange";
        default:
          return "grey";
      }
    },

    getAreaTypeLabel(areaType) {
      switch (areaType) {
        case "PACKING":
          return "Empaque";
        case "DISPATCH":
          return "Despacho";
        case "STORAGE":
          return "Almacén";
        default:
          return "Desconocido";
      }
    },

    // Métodos para menú kiosco
    async openKioscoMenuDialog() {
      this.kioscoMenuDialog = true;
      await this.loadKioscoItems();
    },

    closeKioscoMenuDialog() {
      this.kioscoMenuDialog = false;
    },

    async loadKioscoItems() {
      this.kioscoLoading = true;
      try {
        const payload = {
          business_unit_id: this.lastFilters.business,
          location_id: this.lastFilters.location,
        };

        const response = await this.api_Post("inventory/kiosco_menu_items", payload);
        if (response.ok) {
          const data = await response.json();
          // Agregar propiedad para controlar el estado de eliminación
          this.kioscoItems = data.map((item) => ({
            ...item,
            removing: false,
          }));
        } else {
          this.$toast.error("Error cargando artículos del kiosco");
        }
      } catch (error) {
        this.$toast.error("Error cargando artículos del kiosco");
      } finally {
        this.kioscoLoading = false;
      }
    },

    async refreshKioscoItems() {
      await this.loadKioscoItems();
      this.$toast.success("Artículos actualizados");
    },

    async toggleKioscoItem(item) {
      // Marcar el item como en proceso de toggle
      this.$set(item, "toggling", true);

      try {
        const response = await this.api_Patch(
          `inventory/toggle_kiosco_item/${item.catalogue_detail_id}`,
          {
            show_express: !item.show_express,
            updated_by: this.$store.state.auth.user.user.user_id,
          }
        );

        if (response.ok) {
          // Actualizar el estado local
          item.show_express = !item.show_express;
          this.$toast.success(
            item.show_express
              ? "Artículo agregado al menú kiosco"
              : "Artículo removido del menú kiosco"
          );
        } else {
          const error = await response.json();
          this.$toast.error(error.error || "Error actualizando artículo");
        }
      } catch (error) {
        this.$toast.error("Error actualizando artículo");
      } finally {
        // Quitar el estado de toggle
        this.$set(item, "toggling", false);
      }
    },

    async removeItemFromKioscoMenu(item) {
      // Marcar el item como en proceso de eliminación
      this.$set(item, "removing", true);

      try {
        const response = await this.api_Patch(
          `inventory/toggle_kiosco_item/${item.catalogue_detail_id}`,
          {
            show_express: false,
            updated_by: this.$store.state.auth.user.user.user_id,
          }
        );

        if (response.ok) {
          this.$toast.success("Artículo removido del menú kiosco");
          // Remover el item de la lista
          const index = this.kioscoItems.findIndex(
            (kioscoItem) => kioscoItem.catalogue_detail_id === item.catalogue_detail_id
          );
          if (index !== -1) {
            this.kioscoItems.splice(index, 1);
          }
        } else {
          const error = await response.json();
          this.$toast.error(error.error || "Error removiendo artículo del menú");
        }
      } catch (error) {
        this.$toast.error("Error removiendo artículo del menú");
      } finally {
        // Quitar el estado de eliminación
        this.$set(item, "removing", false);
      }
    },

    // Métodos para agregar artículos al menú
    async openAddToMenuDialog() {
      this.addToMenuDialog = true;
      await this.loadAvailableItems();
    },

    closeAddToMenuDialog() {
      this.addToMenuDialog = false;
    },

    async loadAvailableItems() {
      this.loadingAvailableItems = true;
      try {
        const payload = {
          business_unit_id: this.lastFilters.business,
          location_id: this.lastFilters.location,
        };

        const response = await this.api_Post(
          "inventory/catalogue_items_not_in_kiosco",
          payload
        );
        if (response.ok) {
          const data = await response.json();
          // Agregar propiedad para controlar el estado de agregar
          this.availableItems = data.map((item) => ({
            ...item,
            adding: false,
          }));
        } else {
          this.$toast.error("Error cargando artículos disponibles");
        }
      } catch (error) {
        this.$toast.error("Error cargando artículos disponibles");
      } finally {
        this.loadingAvailableItems = false;
      }
    },

    async refreshAvailableItems() {
      await this.loadAvailableItems();
      this.$toast.success("Artículos disponibles actualizados");
    },

    async addItemToKioscoMenu(item) {
      // Marcar el item como en proceso de agregar
      this.$set(item, "adding", true);

      try {
        const response = await this.api_Patch(
          `inventory/toggle_kiosco_item/${item.catalogue_detail_id}`,
          {
            show_express: true,
            updated_by: this.$store.state.auth.user.user.user_id,
          }
        );

        if (response.ok) {
          this.$toast.success("Artículo agregado al menú kiosco");
          // Remover el item de la lista de disponibles
          const index = this.availableItems.findIndex(
            (availableItem) =>
              availableItem.catalogue_detail_id === item.catalogue_detail_id
          );
          if (index !== -1) {
            this.availableItems.splice(index, 1);
          }
          // Actualizar la lista del menú kiosco si está abierta
          if (this.kioscoMenuDialog) {
            await this.loadKioscoItems();
          }
        } else {
          const error = await response.json();
          this.$toast.error(error.error || "Error agregando artículo al menú");
        }
      } catch (error) {
        this.$toast.error("Error agregando artículo al menú");
      } finally {
        // Quitar el estado de agregar
        this.$set(item, "adding", false);
      }
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.status-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.status-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;
}

.v-data-table>>>.v-data-table__wrapper {
  overflow-x: auto;
}

@media (max-width: 768px) {

  .v-data-table>>>th,
  .v-data-table>>>td {
    padding: 0 8px !important;
  }
}

/* Nuevas clases para OrderSale */
.bg-gradient-red {
  background: linear-gradient(135deg, #EF5350 0%, #C62828 100%) !important;
}

.bg-gradient-blue {
  background: linear-gradient(135deg, #42A5F5 0%, #1565C0 100%) !important;
}

.bg-gradient-green {
  background: linear-gradient(135deg, #66BB6A 0%, #2E7D32 100%) !important;
}

.v-data-table>>>.new-order-row {
  background-color: rgba(239, 83, 80, 0.05) !important;
  border-left: 4px solid #EF5350 !important;
}

.v-data-table>>>.new-order-row:hover {
  background-color: rgba(239, 83, 80, 0.1) !important;
}

/* Clases para diálogos mejorados */
.border-left-alert {
  border-left: 6px solid #2196F3 !important;
}

.border-left-alert-green {
  border-left: 6px solid #4CAF50 !important;
}

.border-bottom-light {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.scrollbar-custom::-webkit-scrollbar {
  width: 6px;
}

.scrollbar-custom::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.scrollbar-custom::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

.scrollbar-custom::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.pulse-animation:hover {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.4);
  }

  70% {
    transform: scale(1.02);
    box-shadow: 0 0 0 10px rgba(33, 150, 243, 0);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0);
  }
}
</style>
